import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import history from '../utils/history';

export const getCustomFields = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getCustomFieldsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/custom-fields',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getCustomFieldsSuccess(res.data));
        dispatch(setFields(res.data));
      })
      .catch(err => {
        dispatch(getCustomFieldsFailure(err));
      });
  };
};

export const addCustomField = (entityId, customField) => {
  const sessionId = getSessionId();
  delete customField['entityAttributeId'];
  return dispatch => {
    dispatch(saveCustomFieldsRequest());
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/custom-fields',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: customField,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(addCustomFieldSuccess(res.data));
        history.push('/custom-fields');
      })
      .catch(err => {
        dispatch(saveCustomFieldFailure(err));
      });
  };
};

export const saveCustomField = (entityId, entityAttributeId, customField) => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(saveCustomFieldsRequest());
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/custom-fields/' + entityAttributeId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: customField,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(saveCustomFieldSuccess(res.data));
        history.push('/custom-fields');
      })
      .catch(err => {
        dispatch(saveCustomFieldFailure(err));
      });
  };
};

export const replaceCustomFields = (entityId, sourceEntityId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/custom-fields/replace',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId,
        sourceEntityId: sourceEntityId
      }
    })
      .then(res => {
        dispatch(replaceCustomFieldsSuccess(res.data));
      })
      .catch(err => {
        dispatch(replaceCustomFieldsFailure(err));
      });
  };
};

export const generateCustomFields = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/custom-fields/records',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(generateCustomFieldsSuccess(res.data));
      })
      .catch(err => {
        dispatch(generateCustomFieldsFailure(err));
      });
  };
};

export const deleteCustomField = (entityId, entityAttributeId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/custom-fields/' + entityAttributeId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(deleteCustomFieldSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveCustomFieldFailure(err));
      });
  };
};

export const getTransformationFunctions = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/transformation-functions',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getTransformationFunctionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getTransformationFunctionsFailure(err));
      });
  };
};

export const clearCustomFieldsError = () => {
  return {
    type: Constants.CUSTOMFIELDS_CLEAR_ERROR
  };
};

const getCustomFieldsRequest = () => {
  return {
    type: Constants.CUSTOMFIELDS_GET_REQUEST
  };
};

const getCustomFieldsSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_GET_SUCCESS,
    payload: data
  };
};

const getCustomFieldsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMFIELDS_GET_FAILURE,
    payload
  };
};

const addCustomFieldSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_ADD_SUCCESS,
    payload: data
  };
};

const saveCustomFieldsRequest = data => {
  return {
    type: Constants.CUSTOMFIELDS_SAVE_REQUEST,
    payload: data
  };
};

const saveCustomFieldSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_SAVE_SUCCESS,
    payload: data
  };
};

const saveCustomFieldFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMFIELDS_SAVE_FAILURE,
    payload
  };
};

const generateCustomFieldsSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_GENERATE_SUCCESS,
    payload: data
  };
};

const generateCustomFieldsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMFIELDS_GENERATE_FAILURE,
    payload
  };
};

const deleteCustomFieldSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_DELETE_SUCCESS,
    payload: data
  };
};

const getTransformationFunctionsSuccess = data => {
  return {
    type: Constants.TRANSFORMFUNCTIONS_GET_SUCCESS,
    payload: data
  };
};

const getTransformationFunctionsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.TRANSFORMFUNCTIONS_GET_FAILURE,
    payload
  };
};

const setFields = data => {
  return {
    type: Constants.FIELDS_GET_CUSTOMFIELDS,
    payload: data
  };
};

const replaceCustomFieldsSuccess = data => {
  return {
    type: Constants.CUSTOMFIELDS_REPLACE_SUCCESS,
    payload: data
  };
};

const replaceCustomFieldsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CUSTOMFIELDS_REPLACE_FAILURE,
    payload
  };
};
